import { render } from "./Contact.vue?vue&type=template&id=2aef1710&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=2aef1710&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2aef1710"

export default script